<div class="card overflow-hidden">
  <div class="card-img-top position-relative">
    @if (imageLoading()) {
      <div
        class="img-placeholder d-flex align-items-center justify-content-center bg-light"
      >
        <div class="card-image-loading">
          <div class="spinner-border spinner-border-sm" role="status">
            <span class="visually-hidden"></span>
          </div>
          <span>{{ "general.loading" | translate }}</span>
        </div>
      </div>
    } @else if (imageSrc) {
      <img [src]="imageSrc" class="img-fluid" />
    } @else {
      <div
        class="img-placeholder d-flex align-items-center justify-content-center bg-light"
      >
        <div class="card-image-placeholder-content">
          <span class="fas fa-image" aria-hidden="true"></span>
          <span class="small">{{ "general.noImage" | translate }}</span>
        </div>
      </div>
    }

    @if (project().classification?.code) {
      <div
        class="classification-badge {{
          project().classification!.code.split('-')[0].toLocaleLowerCase()
        }}"
        title="{{ project().classification!.description }}"
      >
        {{ project().classification!.code }}
      </div>
    }
  </div>
  <div class="card-body">
    <div class="card-title" [title]="project().name">{{ project().name }}</div>
    <div class="project-detail-line">
      <div class="project-description">
        {{ "projectCard.interestValueCommitted" | translate }}
      </div>
      <small
        ><b
          >{{ project().interestMin ?? "-" }}% -
          {{ project().interestMax ?? "-" }}%</b
        ></small
      >
    </div>
    <div class="project-detail-line">
      <div class="project-description">
        {{ "projectCard.recommendedYield" | translate }}
      </div>
      <small
        ><b
          >{{ project().yieldMin ?? "-" }}% -
          {{ project().yieldMax ?? "-" }}%</b
        ></small
      >
    </div>
    <div class="project-detail-line">
      <div class="project-description">
        {{ "projectCard.term" | translate }}
      </div>
      <small
        ><b>{{
          project().loanTypePaymentStart
            | periodDuration: project().loanTypePaymentEnd
        }}</b></small
      >
    </div>
    <div class="project-detail-line">
      <div class="project-description">
        {{ "projectCard.collectionPeriod" | translate }}
      </div>
      <small>
        <b
          >{{ getDateString(project().loanTypePaymentStart) }} -
          {{ getDateString(project().loanTypePaymentEnd) }}</b
        ></small
      >
    </div>
    <div class="project-detail-line">
      <div class="project-description">
        {{ "projectCard.scheduledPaymentDate" | translate }}
      </div>
      <small
        ><b>{{ getDateString(project().targetColletionEndDate) }}</b></small
      >
    </div>
    <hr />
    <div>
      <div class="goal-text">
        {{
          "projectCard.goalText"
            | translate
              : {
                  goal: project().targetAmount,
                  currency: project().currency,
                  progress:
                    (project().currentAmount / project().targetAmount) * 100
                    | threeDecimals,
                }
        }}
      </div>
      <div class="goal-amount">
        {{ project().currentAmount }} {{ project().currency }}
      </div>
      <div>
        @if (isInvestOpen()) {
          <small>{{ "projectCard.investmentsArePossible" | translate }}</small>
        }
      </div>
    </div>
    <div class="button-container">
      @if (showDetailsButton()) {
        <a
          class="btn btn-outline-secondary btn-sm me-1 mb-1"
          (click)="onDetailsClicked.emit(project().id)"
          ><span class="bi-list"></span>{{ "general.details" | translate }}</a
        >
      }
      @if (showFollow()) {
        @if (
          displayType() === "underPreparation" ||
          displayType() === "followedUnderPreparation"
        ) {
          @if (!!projectsStore.allFollowedProjectEntityMap()[project().id]) {
            <a
              class="details-follow-btn w-100"
              (click)="unFollow(project().id)"
            >
              <div>
                <span class="fas fa-heart"></span>
                {{ "general.unFollow" | translate }}
              </div>
            </a>
          } @else {
            <a class="details-follow-btn w-100" (click)="follow(project().id)">
              <div>
                <span class="far fa-heart"></span>
                {{ "general.follow" | translate }}
              </div>
            </a>
          }
        } @else {
          @if (!!projectsStore.allFollowedProjectEntityMap()[project().id]) {
            <a
              class="btn btn-outline-secondary btn-sm me-1 mb-1"
              (click)="unFollow(project().id)"
              ><span class="fas fa-star"></span
              >{{ "general.unFollow" | translate }}</a
            >
          } @else {
            <a
              class="btn btn-outline-secondary btn-sm me-1 mb-1"
              (click)="follow(project().id)"
              ><span class="fas fa-star"></span
              >{{ "general.follow" | translate }}</a
            >
          }
        }
      }
    </div>
  </div>
</div>
